module.exports = __webpack_public_path__ + "img/Boston.7770cea9.jpg";